/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".margin-top-form[_ngcontent-%COMP%]{margin-top:2%;padding:2%}input[type=submit][_ngcontent-%COMP%]{width:100%}.container[_ngcontent-%COMP%]{background:#f5f5f5}.recaptcha[_ngcontent-%COMP%]{width:90%}"];
export { styles as styles };
